import React, { type ReactNode } from 'react';
import { Accordion } from 'react-bootstrap';
import { clsx } from '../helpers/clsx.js';

interface ICommsCollapse {
  title: ReactNode;
  visible: boolean;
  clickFunction: () => void;
  children: ReactNode;
  titleIcon: ReactNode;
  className?: string;
}
export const CommsCollapseWidget = ({
  title,
  visible,
  children,
  clickFunction,
  titleIcon,
  className,
}: ICommsCollapse) => {
  return (
    <Accordion activeKey={visible ? '0' : undefined} onSelect={() => clickFunction()} className={clsx(className)}>
      <Accordion.Item eventKey="0">
        <Accordion.Header className={clsx('mb-0', 'p-0', 'm-0')}>
          <h6 className="m-0 p-0">
            <span className="me-3">{titleIcon}</span>
            <span>{title}</span>
          </h6>
        </Accordion.Header>
        <Accordion.Body className="">{children}</Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};
